module.exports = __webpack_public_path__ + "img/1.Heavy22ktGoldNecklaceSet.d76b9fe6.png";